import React, { useState } from "react";
import "./Search_offcanvas.css";
import { Button, Dropdown, Form, InputGroup, Offcanvas } from "react-bootstrap";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import Popular_product_cards from "../../Common-Component/popular_product_cards/Popular_product_cards";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import Orange_Round_Arrow_Btn from "../../Common-Component/Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";

function Search_offcanvas({ showSearchOffcanvas, onHideSearchOffcanvas }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // Sample suggestions (Replace with API data if needed)
  const suggestions = [
    "Business Cards",
    "Stickers & Labels",
    "Caps",
    "Awards",
    "Photo Gifts",
    "Corporate Gifts",
  ];

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.length > 0) {
      const filtered = suggestions.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(filtered);
      setShowDropdown(filtered.length > 0);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSelectSuggestion = (suggestion) => {
    setSearchTerm(suggestion);
    setShowDropdown(false);
  };
  return (
    <section className="Search_offcanvas_holder">
      <Offcanvas
        show={showSearchOffcanvas}
        onHide={onHideSearchOffcanvas}
        placement="top"
        className="Search_offcanvas"
      >
        <div className="custom_container">
          <Offcanvas.Header>
            <Form className="header_search_holder">
              <div className="search-dropdown-wrapper">
                <InputGroup className="searchbar_holder">
                  <Form.Control
                    className="mb-0"
                    placeholder="Search Products..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <InputGroup.Text id="basic-addon1">
                    <FontAwesomeIcon
                      className="header_icon"
                      icon={faMagnifyingGlass}
                    />
                  </InputGroup.Text>
                </InputGroup>

                {showDropdown && (
                  <Dropdown className="search-dropdown">
                    <Dropdown.Menu show>
                      {filteredSuggestions.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => handleSelectSuggestion(item)}
                        >
                          {item}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
              <div className="offcanvas_close_btn_holder">
                <Button
                  className="cancel_offcanvas_btn"
                  onClick={onHideSearchOffcanvas}
                >
                  Cancel{" "}
                  <FontAwesomeIcon
                    className="close_icon"
                    icon={faCircleXmark}
                  />
                </Button>
              </div>
            </Form>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="offcanvas_heading_holder">
              <h4>Most Popular Product</h4>
            </div>

            <div className="popular_product_cards_holder">
              <Swiper
                spaceBetween={20}
                slidesPerView={5}
                className="popular_product_cards_swiper"
                breakpoints={{
                  320: { slidesPerView: 2, spaceBetween: 10 }, // Small screens
                  420: { slidesPerView: 2.5, spaceBetween: 10 }, // Small screens
                  480: { slidesPerView: 3, spaceBetween: 15 }, // Mobile
                  768: { slidesPerView: 4, spaceBetween: 20 }, // Tablets
                  992: { slidesPerView: 4.5, spaceBetween: 20 }, // Tablets
                  1024: { slidesPerView: 4.5, spaceBetween: 20 }, // Small desktops
                  1200: { slidesPerView: 5, spaceBetween: 20 }, // Large desktops
                }}
              >
                <SwiperSlide>
                  <Popular_product_cards
                    card_heading={"Business Cards"}
                    imgSrc={"/assets/Images/Popular_product_cards/lifafa.png"}
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <Popular_product_cards
                    card_heading={"Stickers & Label"}
                    imgSrc={"/assets/Images/Popular_product_cards/caps.png"}
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <Popular_product_cards
                    card_heading={"Caps"}
                    imgSrc={"/assets/Images/Popular_product_cards/caps.png"}
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <Popular_product_cards
                    card_heading={"Awards"}
                    imgSrc={"/assets/Images/Popular_product_cards/trophy.png"}
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <Popular_product_cards
                    card_heading={"Photo Gifts"}
                    imgSrc={"/assets/Images/Popular_product_cards/frames.png"}
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <Popular_product_cards
                    card_heading={"Corporate Gifts"}
                    imgSrc={"/assets/Images/Popular_product_cards/food_kit.png"}
                  />
                </SwiperSlide>
              </Swiper>
            </div>

            <div className="explore_btn_holder">
              <Orange_Round_Arrow_Btn btn_name={"Explore Now"} />
            </div>
          </Offcanvas.Body>
        </div>
      </Offcanvas>
    </section>
  );
}

export default Search_offcanvas;
